import { render, staticRenderFns } from "./applyToiletries.vue?vue&type=template&id=faa91880&scoped=true"
import script from "./applyToiletries.vue?vue&type=script&lang=js"
export * from "./applyToiletries.vue?vue&type=script&lang=js"
import style0 from "./applyToiletries.vue?vue&type=style&index=0&id=faa91880&prod&lang=scss"
import style1 from "./applyToiletries.vue?vue&type=style&index=1&id=faa91880&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa91880",
  null
  
)

export default component.exports